import { EditorialBlocks } from '_features/RankingPage/components/EditorialBlocks';
import type { RankingBlock } from '_features/RankingPage/types';

import type { GuideBlock } from '../types';

export type SharedGuideBlock = Exclude<RankingBlock, { type: 'quote' }>;

interface GuideBlockListProps {
  blocks: readonly GuideBlock[];
  locale: string;
  serviceName: string;
  path: string;
}

const GUIDE_ONLY_TYPES = new Set([
  'tabs',
  'scale',
  'decisionTree',
  'checklist',
  'quiz',
  'seats',
  'roi',
  'simulator',
  'calculator',
  'billingUnit',
  'briefBuilder',
  'robots',
  'promptPanel',
  'timeline',
  'callout',
  'quote',
]);

export const isSharedBlock = (block: GuideBlock): block is SharedGuideBlock => !GUIDE_ONLY_TYPES.has(block.type);

export const GuideBlockList = (props: GuideBlockListProps) => {
  const { blocks, locale, serviceName, path } = props;
  const shared = blocks.filter(isSharedBlock);

  if (shared.length === 0) return null;

  return <EditorialBlocks blocks={shared} locale={locale} serviceName={serviceName} path={path} />;
};
